module.exports = __webpack_public_path__ + "img/historia17.5adf18ea.jpg";